// extracted by mini-css-extract-plugin
module.exports = {"indigo":"title_indigo__2Vl-m","night":"title_night__1pVwN","subTextSpacing":"title_subTextSpacing__1eaJM","title":"title_title__3u9El","subHeaderText":"title_subHeaderText__2hsiY"};